<template>
  <div class="survey-not-found-container">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8-desktop is-10-tablet">
          <div class="card">
            <header class="card-header">
              <div class="card-header-title is-block has-text-centered">
                <div class="icon-wrapper muted">
                  <b-icon
                    icon="file-question"
                    size="is-large"
                    custom-class="has-text-grey"
                  />
                </div>
                <h1
                  class="title is-spaced is-size-2-desktop is-size-4-mobile has-text-weight-bold mt-4 mb-2"
                >
                  Encuesta No Encontrada
                </h1>
                <p
                  class="subtitle is-size-5-desktop is-size-6-mobile has-text-grey"
                >
                  No pudimos encontrar la encuesta que buscas
                </p>
              </div>
            </header>

            <div class="card-content">
              <div class="content has-text-centered">
                <p class="has-text-grey-dark mb-4" style="line-height: 1.6;">
                  La encuesta a la que intentas acceder no existe o el enlace
                  puede estar incorrecto.
                </p>

                <div class="info-box">
                  <p class="is-size-7 has-text-grey" style="line-height: 1.6;">
                    Verifica que el enlace sea correcto o contacta a la persona
                    que te compartió la encuesta.
                  </p>
                </div>
              </div>
            </div>

            <footer v-if="showBackButton" class="card-footer">
              <div class="card-footer-item">
                <b-button
                  type="is-light"
                  size="is-medium"
                  expanded
                  @click="handleGoBack"
                >
                  Volver
                </b-button>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyNotFound",

  props: {
    showBackButton: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleGoBack() {
      this.$emit("go-back");
    },
  },
};
</script>

<style scoped>
.survey-not-found-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header-title {
  padding: 2rem 1.5rem;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
}

.icon-wrapper.muted {
  background-color: #f5f5f5;
}

.card-content {
  padding: 1.5rem;
}

.info-box {
  background-color: rgba(245, 245, 245, 0.8);
  border-radius: 6px;
  padding: 1rem;
}

.card-footer-item {
  padding: 1.5rem;
  display: block;
}

/* Responsive adjustments */
@media screen and (max-width: 768px) {
  .survey-not-found-container {
    padding: 1rem;
  }

  .card-header-title {
    padding: 1.5rem 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .title.is-3 {
    font-size: 1.5rem;
  }

  .icon-wrapper {
    width: 3.5rem;
    height: 3.5rem;
  }

  .info-box {
    padding: 0.75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/SurveyNotFound.vue